import { POS_ABBR, type Position } from "./positions.js";

// ---- Tagged filename (shared by overlay + ODP pages) ----

const BASE58 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
const SUFFIX_RE = /-(overlay|card)-\d{14}-[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{8}$/;

function base58Id(len = 8): string {
  const arr = new Uint8Array(len);
  crypto.getRandomValues(arr);
  return Array.from(arr, (b) => BASE58[b % 58]!).join("");
}

function ts14(): string {
  const d = new Date();
  const p = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}${p(d.getHours())}${p(d.getMinutes())}${p(d.getSeconds())}`;
}

export function taggedFilename(originalName: string, tag: "overlay" | "card"): string {
  const dotIdx = originalName.lastIndexOf(".");
  const stem = dotIdx > 0 ? originalName.slice(0, dotIdx) : originalName;
  const ext = dotIdx > 0 ? originalName.slice(dotIdx) : "";
  const cleanStem = stem.replace(SUFFIX_RE, "");
  return `${cleanStem}-${tag}-${ts14()}-${base58Id()}${ext}`;
}

/**
 * Slug like Python `_slugify`:
 *   for c in text: c if isalnum() or c in "_-" else "_"
 *   strip "_" from edges, truncate to 30.
 *
 * Python `isalnum()` returns True for CJK characters; JS `\w` does not.
 * We use Unicode property escape `\p{L}` (Letter) + `\p{N}` (Number).
 */
export function slugify(text: string): string {
  const cleaned = [...text]
    .map((c) => (/[\p{L}\p{N}_-]/u.test(c) ? c : "_"))
    .join("");
  const stripped = cleaned.replace(/^_+|_+$/g, "");
  return (stripped || "chip").slice(0, 30);
}

export function autoLogoFilename(
  stem: string,
  layout: string,
  variant: string,
  position: Position,
): string {
  return `${stem}.logo-${layout}-${variant}-${POS_ABBR[position]}.png`;
}

export function autoHashtagFilename(
  stem: string,
  text: string,
  themeOrHex: string,
  position: Position,
): string {
  return `${stem}.tag-${slugify(text)}-${themeOrHex}-${POS_ABBR[position]}.png`;
}

export function autoCombinedFilename(
  stem: string,
  logoLayout: string,
  logoVariant: string,
  logoPos: Position,
  hashtagText: string,
  hashtagPos: Position,
  themeOrHex: string,
): string {
  return (
    `${stem}.` +
    `logo-${logoLayout}-${logoVariant}-${POS_ABBR[logoPos]}.` +
    `tag-${slugify(hashtagText)}-${themeOrHex}-${POS_ABBR[hashtagPos]}.png`
  );
}
